import React, { ReactNode, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';

import { hideAlert as hideAlertAction } from './store/actions';
import { alertSelector } from './store/selectors';

type AlertProps = {
  hideAlert?: () => void,
  show: boolean,
  type: string,
  content: ReactNode
}

export const PureAlert = ({
  hideAlert,
  show,
  type,
  content,
}: AlertProps) => {
  if (!show) {
    return null;
  }

  const alertClassnames = classnames([
    'alert',
    ...(hideAlert ? ['alert-dismissible'] : []),
    'show',
    type,
  ]);

  return (
    <div className={alertClassnames} role="alert">
      {content}
      {hideAlert && (
        <button
          type="button"
          className="close"
          onClick={hideAlert}
        >
          <span>&times;</span>
        </button>
      )}
    </div>
  );
};


export const ReduxAlert = () => {
  const dispatch = useDispatch();
  const { show, content, alertType } = useSelector(alertSelector);

  const hideAlert = useCallback(() => {
    dispatch(hideAlertAction());
  }, [dispatch]);

  useEffect(() => {
    hideAlert();
  }, [hideAlert]);

  return (
    <PureAlert
      show={show}
      type={alertType}
      content={content}
      hideAlert={hideAlert}
    />
  );
};
